import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './app.css';
import { App } from './App';
import { ThemeProvider } from './lib/theme';

// Reload when new SW activates. Guard prevents infinite loop if controllerchange
// fires multiple times (e.g. skipWaiting + clientsClaim race on first install).
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    // Fade out the app shell before reload so there's no hard white flash.
    const root = document.getElementById('root');
    if (root) {
      root.style.transition = 'opacity 200ms ease';
      root.style.opacity = '0';
    }
    setTimeout(() => window.location.reload(), 220);
  });

  // Force an immediate SW update check on each page load.
  // Without this the browser defers the check until the NEXT navigation,
  // meaning a new tab still shows the old version until it's reloaded a
  // second time.
  window.addEventListener('load', () => {
    navigator.serviceWorker.ready.then(r => r.update()).catch(() => {}); // silently ignore if SW not registered
  });

  // Also re-check whenever the tab re-gains focus (handles long-lived sessions).
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      navigator.serviceWorker.ready.then(r => r.update()).catch(() => {});
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
